"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const errors = __importStar(require("./errors"));
const itemv2_1 = require("../state/itemv2");
const cross_fetch_1 = require("cross-fetch");
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
class Client {
    constructor(provider, cluster, rpcUrl, apiKey) {
        this.provider = provider;
        this.rpcUrl = rpcUrl;
        this.apiKey = apiKey;
        switch (cluster) {
            case "mainnet-beta": {
                this.baseUrl = "https://api.items.itsboots.xyz";
                this.wsUrl =
                    "wss://3pg01ss3dd.execute-api.us-east-1.amazonaws.com/main";
                break;
            }
            case "devnet": {
                this.baseUrl = "https://dev.api.items.itsboots.xyz";
                this.wsUrl =
                    "wss://7iyl5fcdgd.execute-api.us-east-1.amazonaws.com/main";
                break;
            }
            case "localnet": {
                this.baseUrl = "http://localhost:3000";
                this.wsUrl = "ws://localhost:3001";
                break;
            }
            default: {
                throw new Error(`${cluster} is not a valid Solana cluster option. Choose either 'mainnet-beta', 'devnet' or 'localnet'`);
            }
        }
    }
    // check this list of ingredients can build the item
    async checkIngredients(itemClass, ingredients, builder) {
        // if builder is provided overide the initialized provider
        let recipeBuilder = this.provider.publicKey;
        if (builder !== undefined) {
            recipeBuilder = builder;
        }
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            builder: recipeBuilder.toString(),
        });
        for (const ingredient of ingredients) {
            params.append("ingredientMints", ingredient.itemMint.toString());
            params.append("ingredientAmounts", ingredient.amount.toString());
        }
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/checkIngredients?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 404) {
            return [];
        }
        const recipes = await response.json();
        return recipes;
    }
    async buildIsLive(itemClass, ingredientArgs, buildSecret) {
        // check ingredients and find a valid recipe for the item class we want to build
        const buildableRecipes = await this.checkIngredients(itemClass, ingredientArgs, anchor.web3.PublicKey.default);
        if (buildableRecipes.length <= 0) {
            console.error("no buildable recipes found");
            throw new Error(`no buildable recipes found`);
        }
        const recipe = buildableRecipes[0];
        if (recipe === undefined) {
            console.error("no buildable recipes found");
            throw new Error(`no buildable recipes found`);
        }
        console.log("building item class: %s from recipe: %s", itemClass.toString(), recipe.recipeIndex);
        const buildSecretString = buildSecret ? `&buildSecret=${buildSecret}` : "";
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/buildIsLive?itemClass=${itemClass.toString()}&recipeIndex=${recipe.recipeIndex.toString()}${buildSecretString}`, {
            method: "GET",
            headers: createHeaders(this.rpcUrl, this.apiKey)
        });
        const body = await errors.handleResponse(response);
        const toReturn = body;
        return toReturn;
    }
    async build(itemClass, ingredientArgs, buildSecret, buildAuxData) {
        var _a;
        // check ingredients and find a valid recipe for the item class we want to build
        const buildableRecipes = await this.checkIngredients(itemClass, ingredientArgs);
        if (buildableRecipes.length <= 0) {
            console.error("no buildable recipes found");
            throw new Error(`no buildable recipes found`);
        }
        const recipe = buildableRecipes[0];
        if (recipe === undefined) {
            console.error("no buildable recipes found");
            throw new Error(`no buildable recipes found`);
        }
        console.log("building item class: %s from recipe: %s", itemClass.toString(), recipe.recipeIndex);
        // get start build tx and sign it
        const serializedTx = await this.startBuild(itemClass, recipe.recipeIndex, ingredientArgs, buildSecret, buildAuxData);
        if (recipe.recipeType === itemv2_1.RecipeType.SimpleMint) {
            console.log("simple mint recipe detected. Peforming simple mint");
            const txSig = await this.send(serializedTx, { method: "build" });
            return { itemClass, recipe, txSig };
        }
        const tx = anchor.web3.Transaction.from(Buffer.from(serializedTx, "base64"));
        const signedTx = await this.provider.wallet.signTransaction(tx);
        // open websocket connection
        // browser check
        const isNode = typeof process !== "undefined" && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
        let socket;
        if (isNode) {
            console.log("Node env found");
            socket = new isomorphic_ws_1.default(this.wsUrl);
        }
        else {
            console.log("Client side env found");
            socket = new WebSocket(this.wsUrl);
        }
        const buildRequest = {
            requestType: "build",
            data: {
                ingredients: JSON.stringify(recipe.ingredients),
                startBuildTx: signedTx.serialize().toString("base64"),
                build: itemv2_1.getBuildPda(itemClass, this.provider.publicKey).toString(),
            },
        };
        // on connection open, send the signed start build tx
        socket.onopen = (event) => {
            console.log("websocket event received: %s", JSON.stringify(event));
            console.log("sending build request");
            socket.send(JSON.stringify({ buildRequest: buildRequest }));
        };
        socket.onclose = (event) => {
            console.log("close:", JSON.stringify(event));
        };
        socket.onerror = (event) => {
            console.log("websocket error:", JSON.stringify(event));
        };
        // wait for a response from the websocket api
        const buildOutputRaw = await new Promise((resolve, reject) => {
            socket.onmessage = (event) => {
                try {
                    console.log("received event: %s", JSON.stringify(event));
                    resolve(event.data.toString());
                }
                catch (e) {
                    reject(e);
                }
            };
        });
        const buildOutput = JSON.parse(buildOutputRaw);
        let pack;
        if (buildOutput.pack) {
            pack = new anchor.web3.PublicKey(buildOutput.pack);
        }
        const receivedItems = [];
        for (const receivedItem of buildOutput.receivedItems) {
            receivedItems.push([
                new anchor.web3.PublicKey(receivedItem[0]),
                new anchor.BN(receivedItem[1]),
            ]);
        }
        const buildResult = {
            build: new anchor.web3.PublicKey(buildOutput.build),
            pack: pack,
            txSigs: buildOutput.txSigs,
            receivedItems: receivedItems,
        };
        return buildResult;
    }
    async continueBuild(itemClass, builder) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            builder: builder.toString(),
        });
        // return the current build data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/build?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        const buildData = JSON.parse(body.buildData);
        const build = new anchor.web3.PublicKey(body.build);
        console.log("continuing build: %s", JSON.stringify(buildData));
        // if build status is still in progress, check the ingredients we have and add them
        let itemMint;
        if (buildData.status === itemv2_1.BuildStatus.InProgress) {
            // if there are any escrowed ingredients return them to the builder
            if (buildData.ingredients.length > 0) {
                console.log("in progress build with escrowed ingredients detected");
                await this.returnIncompleteBuildIngredients(build);
            }
            await this.cleanBuild(build);
        }
        else {
            itemMint = await this.driveBuild(build);
            return itemMint;
        }
        return null;
    }
    async revertBuild(itemClass, builder) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            builder: builder.toString(),
        });
        console.log(`fetching build to revert with params: ${params}`);
        // return the current build data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/build?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        const buildData = JSON.parse(body.buildData);
        const build = new anchor.web3.PublicKey(body.build);
        console.log("reverting build: %s", JSON.stringify(buildData));
        // if build status is still in progress, check the ingredients we have and add them
        if (buildData.status === itemv2_1.BuildStatus.InProgress) {
            // if there are any escrowed items return them to the builder
            console.log("in progress build with escrowed items detected");
            await this.returnIncompleteBuildIngredients(build);
            await this.cleanBuild(build);
        }
        else {
            console.log("build is not InProgress, cannot revert");
            throw new Error(`Build is not InProgress, cannot revert`);
        }
        const [newBuild, newBuildData] = await this.getBuild(itemClass, builder);
        return newBuild == null;
    }
    async cancelBuild(itemClass, builder) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            builder: builder.toString(),
        });
        // fetch the current build data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/build?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        const buildData = JSON.parse(body.buildData);
        const build = new anchor.web3.PublicKey(body.build);
        // if the build is not in progress then you must continue
        if (buildData.status !== itemv2_1.BuildStatus.InProgress) {
            throw new Error(`Build Cannot be cancelled, please call 'continueBuild'`);
        }
        // return any build ingredients that were added
        await this.returnOrDestroyIngredients(build);
        // clean up build accounts
        await this.cleanBuild(build);
    }
    async getBuild(itemClass, builder) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            builder: builder.toString(),
        });
        // return the current build data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/build?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return [null, null];
        }
        const body = await errors.handleResponse(response);
        const buildData = JSON.parse(body.buildData);
        const build = new anchor.web3.PublicKey(body.build);
        return [build, buildData];
    }
    async getItem(itemMint) {
        const params = new URLSearchParams({
            itemMint: itemMint.toString(),
        });
        // return the current item data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/item?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return [null, null];
        }
        const body = await errors.handleResponse(response);
        const itemData = JSON.parse(body.itemData);
        const item = new anchor.web3.PublicKey(body.item);
        return [item, itemData];
    }
    async getItemClass(itemClass) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
        });
        // return the current build data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/itemClass?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return null;
        }
        const body = await errors.handleResponse(response);
        const itemClassData = JSON.parse(body.itemClassData);
        return itemClassData;
    }
    async getRecipe(recipe) {
        const params = new URLSearchParams({
            recipe: recipe.toString(),
        });
        // return the current build data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/recipe?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return null;
        }
        const body = await errors.handleResponse(response);
        const recipeData = JSON.parse(body.recipeData);
        return recipeData;
    }
    // get all pack data
    async getPack(pack) {
        const params = new URLSearchParams({
            pack: pack.toString(),
        });
        // return the pack data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/pack?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return null;
        }
        const body = await errors.handleResponse(response);
        return [body.pack, body.items, body.packConfig];
    }
    async getPackItemClass(itemClass) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
        });
        // return the pack data
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/packItemClass?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return null;
        }
        const body = await errors.handleResponse(response);
        return body.packConfig;
    }
    async getDeterministicIngredientOutput(deterministicIngredientMint, itemClass) {
        const params = new URLSearchParams({
            deterministicIngredientMint: deterministicIngredientMint.toString(),
            itemClass: itemClass.toString(),
        });
        // return the deterministic ingredient outputs
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/deterministicIngredientOutput?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        if (response.status === 400) {
            return null;
        }
        const body = await errors.handleResponse(response);
        const output = JSON.parse(body.output);
        return output;
    }
    async startBuild(itemClass, recipeIndex, ingredientArgs, buildSecret, buildAuxData) {
        const startBuildTxResponse = await cross_fetch_1.fetch(`${this.baseUrl}/startBuild`, {
            method: "POST",
            headers: createHeaders(this.rpcUrl, this.apiKey),
            body: JSON.stringify({
                itemClass: itemClass.toString(),
                builder: this.provider.wallet.publicKey.toString(),
                recipeIndex: recipeIndex.toString(),
                ingredientArgs: JSON.stringify(ingredientArgs),
                buildSecret: buildSecret ? buildSecret : null,
                buildAuxData: buildAuxData ? JSON.stringify(buildAuxData) : null,
            }),
        });
        const body = await errors.handleResponse(startBuildTxResponse);
        return body.tx;
    }
    // escrow items from builder to the build pda
    async addIngredient(builder, itemClass, ingredient) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            builder: builder.toString(),
            payer: this.provider.publicKey.toString(),
            ingredientMint: ingredient.itemMint.toString(),
            ingredientItemClass: ingredient.itemClass.toString(),
            amount: ingredient.amount.toString(),
        });
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/addIngredient?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        // send ingredient to build
        const addIngredientTxSig = await this.send(body.tx);
        console.log("addIngredientTxSig: %s", addIngredientTxSig);
    }
    // TODO: we only support native sol right now
    async escrowPayment(build) {
        console.log("escrowing payment to build: %s", build.toString());
        const params = new URLSearchParams({
            build: build.toString(),
        });
        try {
            const response = await cross_fetch_1.fetch(`${this.baseUrl}/escrowPayment?` + params, {
                headers: createHeaders(this.rpcUrl, this.apiKey),
            });
            const body = await errors.handleResponse(response);
            const txSig = await this.send(body.tx);
            console.log("escrowPaymentTxSig: %s", txSig);
        }
        catch (e) {
            console.error(e);
        }
    }
    // TODO: we only support native sol right now
    async transferPayment(build) {
        console.log("transfering payment from build escrow: %s", build.toString());
        const params = new URLSearchParams({
            build: build.toString(),
            payer: this.provider.publicKey.toString(),
        });
        try {
            const response = await cross_fetch_1.fetch(`${this.baseUrl}/transferPayment?` + params, {
                headers: createHeaders(this.rpcUrl, this.apiKey),
            });
            const body = await errors.handleResponse(response);
            const txSig = await this.send(body.tx);
            console.log("transferPaymentTxSig: %s", txSig);
        }
        catch (e) {
            console.error(e);
        }
    }
    // mark build as complete, contract checks that required ingredients have been escrowed
    async completeBuild(build) {
        const params = new URLSearchParams({
            build: build.toString(),
        });
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/completeBuild?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        console.log("completeBuild body: %s", body);
        if (body.result === undefined) {
            return undefined;
        }
        // return pack pda if its defined
        if (body.result.pack) {
            return new anchor.web3.PublicKey(body.result.pack);
        }
        return undefined;
    }
    // the builder will receive the output of the build here
    async receiveItem(build) {
        const params = new URLSearchParams({
            build: build.toString(),
        });
        console.log("fetching receive item for build: %s", build.toString());
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/receiveItem?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        console.log("receiveItemResult:", body);
        return body;
    }
    // clean up all build artifacts
    async cleanBuild(build) {
        const params = new URLSearchParams({
            build: build.toString(),
        });
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/cleanBuild?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        console.log("cleanBuildTxSig: %s", body.txSig);
        return body.itemMint;
    }
    // apply the post build effects to each ingredient
    // things like cooldowns and degradation
    async applyBuildEffects(build) {
        const params = new URLSearchParams({
            build: build.toString(),
        });
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/applyBuildEffect?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        console.log("applyBuildEffectTxSig: %s", body.txSig);
    }
    async verifyIngredient(builder, itemClass, ingredientMint, ingredientItemClass) {
        const params = new URLSearchParams({
            itemClass: itemClass.toString(),
            ingredientMint: ingredientMint.toString(),
            ingredientItemClass: ingredientItemClass.toString(),
            builder: builder.toString(),
            payer: this.provider.publicKey.toString(),
        });
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/verifyIngredient?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        const txSig = await this.send(body.tx);
        console.log("verifyIngredientTxSig: %s", txSig);
    }
    async returnOrDestroyIngredients(build) {
        const params = new URLSearchParams({
            build: build.toString(),
        });
        let done = false;
        while (!done) {
            const response = await cross_fetch_1.fetch(`${this.baseUrl}/returnOrDestroyIngredients?` + params, {
                headers: createHeaders(this.rpcUrl, this.apiKey),
            });
            const body = await errors.handleResponse(response);
            // if done signal is returned, exit
            if (body.done) {
                console.log("all build ingredients handled");
                return;
            }
            console.log("returnOrDestroyIngredientsTxSig: %s", body.txSig);
            done = body.done;
        }
    }
    // drive build to completion, these are all permissionless steps
    async driveBuild(build) {
        // complete build
        console.log("completing build: %s", build.toString());
        await this.completeBuild(build);
        console.log("receiving item: %s", build.toString());
        const result = await this.receiveItem(build);
        console.log("applying build effects: %s", build.toString());
        // apply build effects to the ingredients used
        await this.applyBuildEffects(build);
        console.log("returning or destroying ingredients: %s", build.toString());
        // return or destroy the build ingredients in accordance with the effects
        await this.returnOrDestroyIngredients(build);
        console.log("cleaning up build: %s", build.toString());
        // clean up
        await this.cleanBuild(build);
        console.log("build driven: %s", build.toString());
        return result;
    }
    async returnIncompleteBuildIngredients(build) {
        const params = new URLSearchParams({
            build: build.toString(),
        });
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/returnIncompleteBuildIngredients?` + params, {
            headers: createHeaders(this.rpcUrl, this.apiKey),
        });
        const body = await errors.handleResponse(response);
        return body.txSigs;
    }
    // sign and send a transaction received from the items api
    async send(txBase64, auxData = {}) {
        const tx = anchor.web3.Transaction.from(Buffer.from(txBase64, "base64"));
        const signedTx = await this.provider.wallet.signTransaction(tx);
        const response = await cross_fetch_1.fetch(`${this.baseUrl}/send`, {
            method: "POST",
            headers: createHeaders(this.rpcUrl, this.apiKey),
            body: JSON.stringify({
                tx: signedTx.serialize().toString("base64"),
                auxData
            }),
        });
        const body = await errors.handleResponse(response);
        return body.txSig;
    }
}
exports.Client = Client;
function getMissingIngredients(recipeIngredients, buildData) {
    const missingIngredients = [];
    for (const currentIngredient of buildData.ingredients) {
        console.log(currentIngredient);
        // if this build ingredient already has escrowed the required amount, we dont need it
        if (new anchor.BN(currentIngredient.currentAmount).gte(new anchor.BN(currentIngredient.requiredAmount))) {
            continue;
        }
        // find the recipe ingredient which matches the build ingredient required item class
        for (const recipeIngredient of recipeIngredients) {
            if (recipeIngredient.itemClass.equals(currentIngredient.itemClass)) {
                missingIngredients.push(recipeIngredient);
            }
        }
    }
    return missingIngredients;
}
function createHeaders(rpcUrl, apiKey) {
    const headers = {
        "content-type": "application/json",
        "x-api-key": apiKey,
    };
    // if rpcUrl is provided add it to the header map
    if (rpcUrl !== "") {
        headers["x-rpc-url"] = rpcUrl;
    }
    return headers;
}
